import { WorkerStore } from 'accountant/worker/src/store';
import { setWorkerDraft, getWorkerDraft, getWeeklyWorkingHours } from '../../workersService';
import { CODE_DAYS } from '../../workerConstants';

export function hasWorkshiftInfoDraft() {
  return !!WorkerStore.worker?.workshiftInfo;
}

export function addShiftToDraft(shift, day) {
  const workshiftInfo = getWorkerDraft()?.workshiftInfo || {};
  const associatedWorkshifts = workshiftInfo?.associatedWorkshifts || [];

  const shiftInfo = {
    workshift: shift,
    weekDay: { name: day },
  };

  const workshiftIndex = associatedWorkshifts
    .findIndex(workshift => workshift?.weekDay?.name === day);

  if (workshiftIndex >= 0) {
    associatedWorkshifts[workshiftIndex] = shiftInfo;
  } else {
    associatedWorkshifts.push(shiftInfo);
  }

  const weeklyHours = getWeeklyWorkingHours(associatedWorkshifts);

  Object.assign(workshiftInfo, { associatedWorkshifts, weeklyHours });
  setWorkerDraft({ workshiftInfo });
}

export function addWeekShiftToDraft(shift) {
  const WEEKEND_DAYS = ['SA', 'D'];
  const workshiftInfo = getWorkerDraft()?.workshiftInfo || {};
  const associatedWorkshifts = Object.keys(CODE_DAYS).reduce((acc, day) => {
    if (!WEEKEND_DAYS.includes(day)) {
      acc.push({
        workshift: shift,
        weekDay: { name: day },
      });
    }
    return acc;
  }, []);

  const weeklyHours = getWeeklyWorkingHours(associatedWorkshifts);

  Object.assign(workshiftInfo, { associatedWorkshifts, weeklyHours });
  setWorkerDraft({ workshiftInfo });
}

export function deleteWorkerShiftFromDraft(day) {
  const { workshiftInfo } = getWorkerDraft() || { workshiftInfo: {} };

  const associatedWorkshifts = workshiftInfo.associatedWorkshifts
    .filter(shift => shift?.weekDay.name !== day);

  const weeklyHours = getWeeklyWorkingHours(associatedWorkshifts);

  Object.assign(workshiftInfo, { associatedWorkshifts, weeklyHours });
  setWorkerDraft({ workshiftInfo });
}

export function getVariableShift(isWeeklyJourneyType, shiftInfo) {
  if (isWeeklyJourneyType) {
    return null;
  }

  const result = shiftInfo.associatedWorkshifts && shiftInfo.associatedWorkshifts.length > 0
    ? shiftInfo.associatedWorkshifts.filter(shift => !!shift?.workshift?.id)[0].workshift.id
    : null;

  return result;
}

export function isWeeklyJourney(journeyType) {
  return journeyType.name === 'F' || !journeyType.name;
}

export function hasJourneyType(workshiftInfo) {
  return !!workshiftInfo?.journeyType?.name;
}
